import React from 'react';

function Experience() {
  return (
    <section>
      <h2>Work History</h2>
      <p>No professional experience listed yet.</p>
    </section>
  );
}

export default Experience;